module.exports = __webpack_public_path__ + "img/turkey.d814cb57.png";